export default __webpack_public_path__ + "e06f47d4f3cb8d81250075fe191d42b0.svg";